import axios from 'axios';

const baseURL = process.env.REACT_APP_PAYMENT_BE;

const Host = axios.create({
  baseURL
});

const apiPost = async (url, params) => {
  try {
    const result = await Host.post(url, params);
    if (result) return result.data;
    return null;
  } catch (err) {
    if (err.response) return err.response;
    console.log(err)
  }
}

const apiGet = async (url) => {
  try {
    const result = await Host.get(url);
    if (result) return result.data;
    return null;
  } catch (err) {
    if (err.response) return err.response;
    console.log(err)
  }
}

const apiRequest = async (config) => {
  try {
    const result = await Host.request(config);
    if (result) return result.data;
    return null;
  } catch (err) {
    if (err.response) return err.response;
    console.log(err)
  }
}

export default {
  post: apiPost,
  get: apiGet,
  request: apiRequest,
}